export default __webpack_public_path__ + "static/media/icon1.d8489e62.svg";